import React, { PureComponent } from 'react';

// import i18n from '../../i18n';
import PropTypes from 'prop-types';
import { basePageWrap } from '../BasePage';
import LocalsPresentation from '../../components/LocalsPresentation';
import styles from './LocalProfilePage.module.scss';
import TabbedLists from '../../components/TabbedLists';
import Head from "next/head";

class LocalProfilePage extends PureComponent {
    state = {};

    static defaultProps = {};

    static propTypes = {
        localsPresentation: PropTypes.shape(LocalsPresentation.propTypes),
    };

    render() {
        const {
            preamble,
            title,
            image,
            description,
            socialMedia,
            interests,
            localContent,
        } = this.props;
        return (
            <>
            <Head>
                <link rel="stylesheet" href="/third-party-styling/leaflet/leafletoriginal.css"/>
                <link rel="stylesheet" href="/third-party-styling/leaflet/leaflet.css"/>
                <link rel="stylesheet" href="/third-party-styling/leaflet/leaflet-marker-cluster.css"/>
            </Head>
            <div className={styles['LocalProfilePage']}>
                <div>
                    <LocalsPresentation
                        preamble={preamble}
                        title={title}
                        image={image}
                        description={description}
                        socialMedia={socialMedia}
                        interests={interests}
                    />
                </div>
                <TabbedLists {...localContent} isMyList={false} />
            </div>
            </>
        );
    }
}

export default basePageWrap(LocalProfilePage);
